<template>
  <div>
    <div class="form-group row mb-4" v-if="viewComponentModel.display_name">
      <label class="col-form-label col-lg-2">ชื่อสี</label>
      <label class="col-form-label col-lg-8"
        ><span class="badge-lang">TH</span>{{ viewComponentModel.display_name.th }}</label
      >
    </div>
    <div class="form-group row mb-4" v-if="viewComponentModel.display_name">
      <label class="col-form-label col-lg-2"></label>
      <label class="col-form-label col-lg-8"
        ><span class="badge-lang">EN</span>{{ viewComponentModel.display_name.en }}</label
      >
    </div>
    <div class="form-group row mb-4">
      <label class="col-form-label col-lg-2">สถานะ</label>
      <label class="col-form-label col-lg-8">{{ viewComponentModel.status }}</label>
    </div>
    <div class="form-group row mb-4">
      <label class="col-form-label col-lg-2">ตัวอย่างสี</label>
      <div class="col-lg-8">
        <div class="input-group-append">
          <span class="input-group-text">
            <i
              style="width: 16px; height: 16px"
              :style="{ backgroundColor: viewComponentModel.color_code }"
            ></i
          ></span>
        </div>
      </div>
    </div>
     <color-product-relate
     :colorId="viewComponentModel.id"

    ></color-product-relate>
  </div>
</template>

<script>
import { StatusEnum } from '@/enum/status.enum.js'
import ColorProductRelate from '@/components/color/product-relate'

export default {
  name: 'ColorDetailView',
  components: {
       'color-product-relate': ColorProductRelate,
  },
  props: {
    value: {
      type: Object,
      default: () => {
        return this.viewComponentModel
      },
    },
  },
  mounted() {},
  data() {
    return {
      viewComponentModel: {
        id: null,
        display_name: {
          th: '',
          en: '',
        },
        status: StatusEnum.ACTIVE,
        color_code: '#3D56C0',
        create_info: {
          timestamp: '',
          user_id: '',
          user_name: '',
        },
        update_info: {
          timestamp: '',
          user_id: '',
          user_name: '',
        },
      },
    }
  },
  created: function() {
    if (this.value) this.viewComponentModel = this.value
  },
  watch: {
    value: {
      handler(val) {
        this.viewComponentModel = val
      },
      deep: true,
    },
  },
  methods: {},
}
</script>
